module.exports = __webpack_public_path__ + "static/wordpress-d70573983e167a6536186a19ed4708ae.png";